let module = angular.module('app.resources');

module.factory('Channel', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/channels/:id`,
    { id: '@id' },
    {
      create: {
        method: 'POST',
      },
      update: {
        method: 'PUT',
      },
      getBroadcasts: {
        method: 'GET',
        url: `${API_ROOT}/account/channels/:id/broadcasts`,
        isArray: true,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/channel.js